module.exports = __webpack_public_path__ + "img/room-1.50ead77a.jpg";